import "./Gallery.module.css";
import Header from "@/reusable_sections/Header";
import FirmOverview from "./sections/FirmOverview";
import ProjectPhotoGallery from "./sections/ProjectPhotoGallery";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <Header />
      <FirmOverview />
      <ProjectPhotoGallery />
      <CallToAction />
      <Footer />
    </div>;
}